module.exports = __webpack_public_path__ + "media/images/Y-DNA-5afe04658bf39400d071e3da484f9912.png";